// extracted by mini-css-extract-plugin
module.exports = {"decoration":"SectionDownload_decoration__7dYt5","container":"SectionDownload_container__klxvp","download":"SectionDownload_download__lK_50"};